module.exports = __webpack_public_path__ + "img/empty.3c3b9d10.svg";